(function () {
  var KEY = 'qa-bird-species';
  var TTL = 7 * 24 * 60 * 60 * 1000;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getSel() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!raw || !raw.s || !raw.t || (Date.now() - raw.t) > TTL) { return []; }
      return raw.s;
    } catch (e) { return []; }
  }
  function setSel(list) {
    try {
      if (list.length) { localStorage.setItem(KEY, JSON.stringify({ s: list, t: Date.now() })); }
      else { localStorage.removeItem(KEY); }
    } catch (e) {}
  }

  function initBanner(root) {
    if (root.hasAttribute('data-qa-hb-ready')) { return; }
    root.setAttribute('data-qa-hb-ready', '');
    var photo = root.querySelector('[data-qa-hb-photo]');
    var toggle = root.querySelector('[data-qa-hb-toggle]');
    var panel = root.querySelector('[data-qa-hb-panel]');
    var routing = root.querySelector('[data-qa-hb-routing]');
    var routeWrap = root.querySelector('[data-qa-hb-route-btns]');
    var confirmBtn = root.querySelector('[data-qa-hb-confirm]');
    var clearBtn = root.querySelector('[data-qa-hb-clear]');
    var closeBtn = root.querySelector('[data-qa-hb-close]');
    var backBtn = root.querySelector('[data-qa-hb-back]');
    var shakeEl = root.querySelector('[data-qa-hb-shake]');
    if (!toggle || !panel || !routing || !confirmBtn) return;

    var species = [];
    try { species = JSON.parse(root.querySelector('[data-qa-hb-species]').textContent) || []; } catch (e) {}
    var collectionsUrl = root.getAttribute('data-collections-url') || '/collections';
    var boxes = Array.prototype.slice.call(panel.querySelectorAll('input[type=checkbox]'));

    function checked() {
      return boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
    }
    function syncConfirm() { confirmBtn.disabled = checked().length === 0; }
    function setState(s) {
      root.classList.remove('is-open', 'is-routing');
      if (s) { root.classList.add(s); }
      panel.hidden = s !== 'is-open';
      routing.hidden = s !== 'is-routing';
      toggle.setAttribute('aria-expanded', s === 'is-open' ? 'true' : 'false');
    }

    var saved = getSel();
    boxes.forEach(function (b) { b.checked = saved.indexOf(b.value) > -1; b.addEventListener('change', syncConfirm); });
    syncConfirm();

    toggle.addEventListener('click', function () {
      setState(root.classList.contains('is-open') ? null : 'is-open');
    });
    if (closeBtn) { closeBtn.addEventListener('click', function () { setState(null); }); }
    if (clearBtn) { clearBtn.addEventListener('click', function () { boxes.forEach(function (b) { b.checked = false; }); syncConfirm(); }); }
    if (backBtn) { backBtn.addEventListener('click', function () { setState('is-open'); }); }

    function urlFor(name) {
      for (var i = 0; i < species.length; i++) {
        if (species[i].n === name) { return collectionsUrl + '/' + species[i].h; }
      }
      return null;
    }
    function track(sel) {
      try {
        var kl = (window.klaviyo = window.klaviyo || []);
        kl.push(['identify', { 'Bird species': sel.join(', ') }]);
        kl.push(['track', 'Species Picker Confirmed', {
          'Bird species': sel.join(', '),
          'Species list': sel,
          'Species count': sel.length,
          'Source': 'Homepage'
        }]);
      } catch (e) {}
    }

    confirmBtn.addEventListener('click', function () {
      var sel = checked();
      if (!sel.length) { return; }
      setSel(sel);
      track(sel);
      if (sel.length === 1) {
        var u = urlFor(sel[0]);
        if (u) { setTimeout(function () { window.location.assign(u); }, 150); }
        return;
      }
      routeWrap.innerHTML = '';
      species.forEach(function (sp) {
        if (sel.indexOf(sp.n) === -1) { return; }
        var a = document.createElement('a');
        a.className = 'btn btn--primary qa-hb__route-btn';
        a.href = collectionsUrl + '/' + sp.h;
        a.textContent = sp.n;
        routeWrap.appendChild(a);
      });
      setState('is-routing');
    });

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-qa-hb-slide]'));
    var idx = 0;
    var timer = null;
    var secs = parseInt(root.getAttribute('data-rotate') || '6', 10);
    var auto = root.getAttribute('data-autoplay') === 'true';
    function show(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
      idx = i;
    }
    function next() { show((idx + 1) % slides.length); }
    function start() {
      if (!auto || reducedMotion || slides.length < 2 || timer) { return; }
      timer = setInterval(next, secs * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    start();
    if (photo) {
      photo.addEventListener('mouseenter', stop);
      photo.addEventListener('mouseleave', start);
    }

    if (shakeEl && !reducedMotion) {
      setInterval(function () {
        if (root.classList.contains('is-open') || root.classList.contains('is-routing')) { return; }
        shakeEl.classList.add('qa-hb__cta--shake');
        setTimeout(function () { shakeEl.classList.remove('qa-hb__cta--shake'); }, 700);
      }, 5000);
    }

    document.addEventListener('shopify:block:select', function (e) {
      if (!e.target || !e.target.closest) { return; }
      var b = e.target.closest('[data-qa-hb-slide]');
      if (b && slides.indexOf(b) > -1) { stop(); show(slides.indexOf(b)); }
    });
  }

  function init() {
    document.querySelectorAll('[data-qa-hb]').forEach(initBanner);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-qa-hb]').forEach(initBanner);
    }
  });
})();
